import { Deserializable } from '../protocols/deserializable';
import * as moment from 'moment';

export abstract class BaseRemittanceNewMember implements Deserializable {
  public id!: string;
  public firstName!: string;
  public lastName!: string;
  public socialInsuranceNumber!: string;
  public birthDate!: string;
  public newMemberDetails!: RemittanceNewMemberDetails;

  public onDeserialize(): void {
    if (!!this.newMemberDetails) {
      this.newMemberDetails = window?.injector?.Deserialize?.instanceOf(
        RemittanceNewMemberDetails,
        this.newMemberDetails
      );
    } else {
      this.newMemberDetails = new RemittanceNewMemberDetails();
    }
  }
}

export class RemittanceNewMemberDetails implements Deserializable {
  public id!: string;
  public contributionId!: string;
  public email!: string;
  public employmentStartDate!: string;
  public onLeave: boolean = false;
  public leaveTypeId: number | null = null;
  public leaveStartDate: string | null = null;
  public leaveExpectedReturnDate: string | null = null;
  public leaveContinuedContributions: boolean | null = null;

  // Not from API
  public formattedEmploymentStartDate!: string;
  public formattedContributionStartDate!: string;
  public formattedLeaveStartDate!: string;
  public formattedLeaveExpectedReturnDate!: string;

  onDeserialize(): void {
    this.formattedEmploymentStartDate = this.employmentStartDate
      ? moment(this.employmentStartDate).format('DD/MM/YYYY')
      : '';
    this.formattedLeaveStartDate = this.leaveStartDate ? moment(this.leaveStartDate).format('DD/MM/YYYY') : '';
    this.formattedLeaveExpectedReturnDate = this.leaveExpectedReturnDate
      ? moment(this.leaveExpectedReturnDate).format('DD/MM/YYYY')
      : '';
  }
}
